module.exports = __webpack_public_path__ + "static/media/avatar5.63e6ca8c.jpg";